/* Zeni launcher. A connected app may handle the cancelable window `zeni:open`
   event with preventDefault(), or expose window.$zeni.open(). Without a chat
   integration the button opens genuine shopping and support options. */
(function () {
  'use strict';
  if (window.__brandZeniLoaded) return;
  window.__brandZeniLoaded = true;

  var dialog = document.querySelector('[data-zeni-dialog]');
  var opener = null;
  if (!dialog) return;

  function setExpanded(open) {
    document.querySelectorAll('[data-zeni-launch]').forEach(function (button) {
      button.setAttribute('aria-controls', dialog.id);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function finishClose() {
    if (dialog.hasAttribute('open')) return;
    document.body.classList.remove('zeni-dialog-open');
    setExpanded(false);
    if (opener && opener.isConnected) opener.focus();
    opener = null;
  }

  function close() {
    if (!dialog.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    finishClose();
  }

  function open(button) {
    if (dialog.hasAttribute('open')) return;
    opener = button;
    var brand = document.documentElement.getAttribute('data-brand') === 'zenmen' ? 'zenmen' : 'precise';
    dialog.querySelectorAll('[data-zeni-brand]').forEach(function (group) {
      group.hidden = group.getAttribute('data-zeni-brand') !== brand;
    });
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.body.classList.add('zeni-dialog-open');
    setExpanded(true);
    dialog.querySelector('[data-zeni-close]').focus();
  }

  function configuredUrl(button) {
    var value = (button.getAttribute('data-zeni-url') || '').trim();
    if (!value) return null;
    try {
      var url = new URL(value, window.location.href);
      return /^(https?:)$/.test(url.protocol) ? url.href : null;
    } catch (error) { return null; }
  }


  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-zeni-launch]');
    if (!button) return;
    event.preventDefault();
    var url = configuredUrl(button);
    if (url) { window.location.assign(url); return; }
    var integrationEvent = new CustomEvent('zeni:open', {
      cancelable: true,
      detail: { trigger: button }
    });
    if (!window.dispatchEvent(integrationEvent)) return;
    if (window.$zeni && typeof window.$zeni.open === 'function') {
      try {
        var result = window.$zeni.open();
        if (result && typeof result.then === 'function') {
          result.then(function (opened) { if (opened === false) open(button); }, function () { open(button); });
        } else if (result === false) open(button);
        return;
      } catch (error) { /* Continue to the usable shopping-help fallback. */ }
    }
    open(button);
  });

  dialog.querySelector('[data-zeni-close]').addEventListener('click', close);
  dialog.addEventListener('close', finishClose);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('a[href]')) close();
  });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); return; }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(dialog.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex="0"]'))
      .filter(function (element) { return !element.disabled && !element.closest('[hidden]'); });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.querySelector('form').addEventListener('submit', function (event) {
    var query = this.querySelector('[name="q"]');
    query.value = query.value.trim();
    if (!query.value) { event.preventDefault(); query.focus(); }
  });
  setExpanded(false);
  document.addEventListener('shopify:section:load', function () { setExpanded(dialog.hasAttribute('open')); });
})();
